import { localizedRoute } from "../../app/support/helpers";

document.addEventListener('DOMContentLoaded', () => {
    const button: HTMLButtonElement | null = document.querySelector("#load-review-btn");
    if (!button) return;

    //@ts-ignore
    const URL: string = localizedRoute('frontend.practitioners.reviews', window.doctori.practitioner.id);

    button.addEventListener('click', async () => loadMoreReviewsEventHandler());

    const loadMoreReviewsEventHandler = async () => {
        //for now, and for the sake of simplicity, let us fetch all reviews
        fetch(URL).then((response) => response.json()).then(data => {
            document.querySelector("#list-of-comment").innerHTML = data;
            button.classList.add("d-none")
        })
    }

})